export const environment = {
    API_URL: "https://back-enecon-gsig.jamsoftco.com/api/",
    production: false,
    version: "2.1.0 (Jam)"
};